import { Metrika } from '../components/metrika';
import { Analytics } from '../components/analytics';

export function test() {
    let metrika = new Metrika;
    let analytics = new Analytics;

    let testNum = document.querySelector('[data-test-num]'),
        btn = document.querySelector('[am-button="test"]'),
        btnBack = document.querySelector('[am-back="test"]'),
        error = document.querySelector(`[am-error="test"]`),
        currentNum = 1,
        comment = [];

    let goToTestBtn = document.querySelectorAll('.js-goToTest');
    goToTestBtn.forEach(function(item) {
        item.addEventListener('click', function() {
            metrika.reachGoal('TEST_BUTTON_MENU', this);
            analytics.event('TEST_BUTTON_MENU', this);
        });
    });

    if (btn) {
        document.querySelectorAll('input[type="radio"]').forEach( function(item) {
            item.addEventListener('click', function() {
                if (error) {
                    error.classList.remove('is-active');
                }
            });
        });

        btn.addEventListener('click', function() {
            let testBlock = document.querySelector(`[data-question-num="${currentNum}"]`),
                testText = document.querySelector(`[data-text-num="${currentNum}"]`),
                currentAnswer = testBlock.querySelectorAll('input[type="radio"]');

            if (testBlock.querySelector('[am-radio="test"].is-active')) {
                error.classList.remove('is-active');

                currentAnswer.forEach( function(item) {
                    if (item.checked) {
                        let shortQuestion = item.parentNode.parentNode.dataset.short;
                        comment[currentNum - 1] = shortQuestion + item.parentNode.innerText;
                    }
                });


                if (!(currentNum + 1 > 6)) {

                    testBlock.classList.remove('is-active');
                    testText.classList.remove('is-active');

                    testBlock = document.querySelector(`[data-question-num="${currentNum + 1}"]`);
                    testBlock.classList.add('is-active');
                    testText = document.querySelector(`[data-text-num="${currentNum + 1}"]`);
                    testText.classList.add('is-active');

                    currentNum += 1;
                    testNum.textContent = currentNum;

                    if (currentNum > 1) {
                        btnBack.classList.add('is-active');
                    } else {
                        btnBack.classList.remove('is-active');
                    }

                    if (currentNum == 2) {
                        metrika.reachGoal('TEST_FORM_START', this);
                        analytics.event('TEST_FORM_START', this);
                    } else {
                        metrika.reachGoal(`TEST_FORM_STEP_${currentNum - 1}`, this);
                        analytics.event(`TEST_FORM_STEP_${currentNum - 1}`, this);
                    }

                } else {

                    let name = 'possible';

                    // modal

                    let modalWindow = document.querySelector(`[data-modal="${name}"]`),
                        answersInput = modalWindow.querySelector(`textarea[name="comment"]`);

                    document.body.style.overflow = 'hidden';
                    document.documentElement.style.overflow = 'hidden';

                    modalWindow.classList.add('is-active');

                    modalWindow.addEventListener('click', function(event) {
                        if (event.target.hasAttribute('data-modal-close')) {
                            document.body.style.overflow = '';
                            document.documentElement.style.overflow = '';

                            modalWindow.classList.remove('is-active');
                        }
                    });

                    // /modal

                    testBlock.classList.remove('is-active');
                    testText.classList.remove('is-active');

                    answersInput.value = comment.join('\n<br>');

                    currentNum = 1;
                    testNum.textContent = currentNum;
                    btnBack.classList.remove('is-active');

                    testBlock = document.querySelector(`[data-question-num="${currentNum}"]`);
                    testBlock.classList.add('is-active');
                    testText = document.querySelector(`[data-text-num="${currentNum}"]`);
                    testText.classList.add('is-active');

                    metrika.reachGoal('TEST_FORM_COMPLETE_YES');
                    analytics.event('TEST_FORM_COMPLETE_YES');
                }
            } else {
                error.classList.add('is-active');
            }

        });

        btnBack.addEventListener('click', function() {
            let testBlock = document.querySelector(`[data-question-num="${currentNum}"]`),
                testText = document.querySelector(`[data-text-num="${currentNum}"]`);

                testBlock.classList.remove('is-active');
                testText.classList.remove('is-active');

                testBlock = document.querySelector(`[data-question-num="${currentNum - 1}"]`);
                testBlock.classList.add('is-active');
                testText = document.querySelector(`[data-text-num="${currentNum - 1}"]`);
                testText.classList.add('is-active');

                currentNum -= 1;
                testNum.textContent = currentNum;

                if (currentNum > 1) {
                    btnBack.classList.add('is-active');
                } else {
                    btnBack.classList.remove('is-active');
                }

        });
    }

}